var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"content":_vm.tooltipText,"placement":"top","disabled":_vm.tooltipDisabled}},[_c('el-input',_vm._b({class:[
                { 'is-error': _vm.textError.length > 0 },
                { 'input-ellipsis': _vm.showEllipsis }
            ],attrs:{"placeholder":_vm.disabled ? '' : _vm.placeholder,"value":_vm.value,"disabled":_vm.disabled,"clearable":_vm.clearable,"size":_vm.size,"autosize":_vm.autosize,"type":_vm.type,"show-password":_vm.showPassword},on:{"input":_vm.updateValue,"blur":_vm.trimValue},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.handleEnter.apply(null, arguments)}}},'el-input',_vm.$attrs,false),[(
                    _vm.showCloseIcon === true &&
                    _vm.disabled === false &&
                    _vm.value &&
                    _vm.type !== 'textarea' &&
                    !_vm.clearable
                )?_c('i',{staticClass:"el-input__icon el-icon-circle-close icon-close",attrs:{"slot":"suffix"},on:{"click":_vm.clearInput},slot:"suffix"}):_vm._e()])],1),(_vm.textError.length > 0)?_c('span',{staticClass:"text-error-input"},[_vm._v(" "+_vm._s(_vm.textError)+" ")]):_vm._e(),(
            _vm.showCloseIcon === true &&
            _vm.disabled === false &&
            _vm.value &&
            _vm.type === 'textarea'
        )?_c('i',{on:{"click":_vm.clearInput}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }